import { initRowStyleCache } from '../../virtual-grid/utils'
const getRowStyle = initRowStyleCache()
export function createHeaderBody () {
  return {
    functional: true,
    name: 'HeaderBody',
    render (_, context) {
      const props = context.props
      const { rowsLength, loadingRow, rowHeight } = props
      const [slots] = context.slots().default || []
      const renderInner = () => {
        const children = []
        for (const rowIndex of Array.from({ length: rowsLength }, (_, i) => i)) {
          children.push(slots.default({
            rowIndex,
            loadingRow,
            fixedRow: true,
            rowStyle: getRowStyle({
              rowIndex,
              rowHeight
            }),
            _index: rowIndex + 1,
          }))
        }
        return children
      }
      const Inner = renderInner()
      return <tbody>
        {
          Inner
        }
      </tbody>
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/header/header-tbody/index.js